import { WelcomeForm } from '@desquared/wave-components-library';
import React from 'react';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';

import styles from './WelcomePage.module.css';

export default function WelcomePage(props) {
  const router = useRouter();
  const r = useTranslations('login_register');

  return (
    <div className={styles.outerContainer}>
      <WelcomeForm
        classOption={styles.paddingContainer}
        logo={props.logo}
        logoRedirect={router.locale === router.defaultLocale ? '/' : `/${router.locale}/`}
        welcomeImage={props.welcomeImage}
        onSubmitForm={() => router.push('/login')}
        registerRedirect={() => router.push('/register')}
        titleText={r('select_title')}
        connectText={r('login_title')}
        registerText={r('register')}
        guestText={r('guest_text')}
        onGuestClick={() => router.push('/select-service')}
      />
    </div>
  );
}
